(function(){
    angular.module('tmx-app').service('lookupService', ['tmxResource','tmxUtility','TMX_FINANCE_CONSTANTS','$q',

        function lookupService(tmxResource,tmxUtility,TMX_FINANCE_CONSTANTS,$q){

            var service=this;
            var returnObject ={};
            var additionalLookups = {};
            localStorage.getItem('culture') == null ?localStorage.setItem('culture',APP_CONSTANTS.default_culture):''
            var resource=tmxResource("Lookup/"+localStorage.getItem('culture'));
            service.getById=resource.getById;
            var lookupDictionary = {};
            var tenant = APP_CONSTANTS.tenant;
            service.clearLocalLookups = function(){
                returnObject = {};
                lookupDictionary = {};
            }

            service.getLocalLookupsByType=function(type){
                return returnObject.lookups.getById(type);
            };

            service.getHiddenValueById = function(lookupId){
                let lookup = lookupDictionary[lookupId];
                if(tmxUtility.exists(lookup)){
                    return lookup.HiddenValue;
                }
                return null;
            }

            service.getLookupByTypeAndHiddenValue=function(type,hiddenValue){
                var lookupByTypeArray = returnObject.lookups.getById(type);
                if(lookupByTypeArray) {
                    var lookupByTypeAndHiddenValue = lookupByTypeArray.filter(function(item){
                        return item.HiddenValue == hiddenValue
                    })
                }      
                return lookupByTypeAndHiddenValue;        
            };

            service.getLookupIdByHiddenValueAndType = function(type, hiddenValue){
                var lookupsArrayByType = returnObject.lookups.getById(type);
                if(!lookupsArrayByType || lookupsArrayByType.length == 0){
                    return null;
                }
                var lookup = lookupsArrayByType.find(x => x.HiddenValue == hiddenValue);
                if(tmxUtility.exists(lookup)){
                    return lookup.LookupId;
                }
                return null;
            }
            var getFilteredLookups = ()=> {
                var resource = tmxResource("Lookup/GetFilteredList/" + localStorage.getItem('culture'));
                var additionalResource = tmxResource("Lookup/GetByUserBranch/" + localStorage.getItem('culture'));
                var deferred = $q.defer();
                var success = function () {
                    if (angular.isDefined(returnObject) && angular.isDefined(additionalLookups) && returnObject.lookups && additionalLookups.lookups) {
                        var names = additionalLookups.lookups.names;
                        names.forEach((name) => {
                            returnObject.lookups[name] = additionalLookups.lookups[name];
                            returnObject.lookups.names.push(name);
                        });
                        returnObject.lookups.total += additionalLookups.lookups.total;
                        returnObject.lookups.totalValues += additionalLookups.lookups.totalValues;
                    }
                    deferred.resolve(returnObject);
                };
                if (!angular.isDefined(returnObject.lookups)) {
                    getLookupsFromServer(resource, returnObject, tmxUtility, onBasisOfType, success, lookupDictionary);
                    getLookupsFromServer(additionalResource, additionalLookups, tmxUtility, onBasisOfType, success, lookupDictionary);
                }
                else success();
                return deferred.promise;
            };
            service.getLookups=function(){
                if (tenant == TMX_FINANCE_CONSTANTS.TENANTS.UBANK) {
                    return getFilteredLookups();
                }
                else {
                    var resource=tmxResource("Lookup/"+localStorage.getItem('culture'));
                    var deferred = $q.defer();
                    var success = function () {
                        deferred.resolve(returnObject);
                    };
                    if (!angular.isDefined(returnObject.lookups)) {
                        getLookupsFromServer(resource, returnObject, tmxUtility, onBasisOfType, success, lookupDictionary);
                    }
                    else success();
                    return deferred.promise;
                }
            };

            service.getAllLookups = function(){
                var deferred = $q.defer();
                if(!tmxUtility.exists(lookupDictionary) || Object.keys(lookupDictionary).length == 0){
                    lookupDictionary = {};
                    tmxResource("Lookup").all().then(
                        function(response){
                            response.Data.forEach(x=> {lookupDictionary[x.LookupId]=x});
                            deferred.resolve(lookupDictionary);
                        });
                }
                else {
                    deferred.resolve(lookupDictionary);
                }
                return deferred.promise;
            }
         /////////////////////////////////////////////////////////////////////////////////////////////////////////
            service.getScreens=function(){
                var obj=service;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var screens = result.lookups.getById("SCREEN");//calls tmx-utility function
                    deferred.resolve(screens);
                });
                return deferred.promise;
            };
            service.getLoanRepaymentFreq=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    
                    var RepaymentFreq = result.lookups.getById("REPAYMENT_FREQUENCY");//calls tmx-utility function
                    deferred.resolve(RepaymentFreq);
                });
                return deferred.promise;
            };
            service.getLoanTypes=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var loanTypes = result.lookups.getById("LOAN_TYPE");//calls tmx-utility function
                    deferred.resolve(loanTypes);
                });
                return deferred.promise;
            };
            service.getProductTypes=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var loanTypes = result.lookups.getById("Product_Type");//calls tmx-utility function
                    deferred.resolve(loanTypes);
                });
                return deferred.promise;
            };
            service.getByType=function(type){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var ret=result.lookups.getById(type);
                    deferred.resolve(ret);
                });
                return deferred.promise;
            };
            service.getByTypeAndParent=function(type,ParentLookupId){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var ret=result.lookups.getById(type);//first filter by type
                    ret=ret.filter(function(obj){return obj.ParentLookupId==ParentLookupId});
                    deferred.resolve(ret);
                });
                return deferred.promise;
            };

            service.getByTypeAndParentLocal=function(type,ParentLookupId){
                var ret= service.getLocalLookupsByType(type);
                ret = ret.filter(function(obj){return obj.ParentLookupId==ParentLookupId});
                return ret;            
            };
        
            service.getLoanStatusLkp=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var LoanStatus=result.lookups.getById("Loan_Status");
                    deferred.resolve(LoanStatus);
                });
                return deferred.promise;
            };
            service.getLoanApplicationStatusLkp=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var LoanApplicationStatus=result.lookups.getById("APPLICATION_STATUS");
                    deferred.resolve(LoanApplicationStatus);
                });
                return deferred.promise;
            };
            service.getCompanyTypes=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var countries=result.lookups.getById("COMPANY_TYPE");
                    deferred.resolve(countries);
                });
                return deferred.promise;
            };
            service.getRelationships=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var countries=result.lookups.getById("RELATION.CODE");
                    deferred.resolve(countries);
                });
                return deferred.promise;
            };
            service.getAddressType=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var countries=result.lookups.getById("Address Type");
                    deferred.resolve(countries);
                });
                return deferred.promise;
            };
            service.getCompanyClassification=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("COMPANY_CLASS");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getLocationTypes=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("LOCATION_TYPE");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getUserTypes=function(){

                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("USER");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getGender=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("GENDER");//changed from GENDER_TYPE_DESC
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getMaritalStatus=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("Marital Status");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getProfession=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("Occupation");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getTrainings=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("TRAINING");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getResidence=function(){
                 
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var countries=result.lookups.getById("RESIDENCE");
                    deferred.resolve(countries);
                });
                return deferred.promise;
            };
            service.getEducation=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("Education Level");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getPJPType=function(){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(
                    function(result){
                        var countries=result.lookups.getById("PJP_TYPE");
                        deferred.resolve(countries);
                    }
                );
                return deferred.promise;
            };
            service.getReturnObject=function(){
                return returnObject;
            }

            service.getFIELDHiddenValueByVisibleValue=function(VisibleValue){
                var hiddenValue = 0;
                returnObject.lookups.FIELD.forEach(function(item){
                    if(item.VisibleValue == VisibleValue){
                        hiddenValue = item.HiddenValue;
                    }            
                })
                return hiddenValue;            
            }
        
            service.getLookupById = function(id){
                return lookupDictionary[id];
            }

        
            service.getLookupByType=function(Type){
                var obj=this;
                var deferred=$q.defer();
                obj.getLookups().then(function(result){
                    var countries=result.lookups.getById(Type);
                    deferred.resolve(countries);
                });
                return deferred.promise;
            };

            service.getAllLocales = function(){
                return tmxResource("Lookup").getByAction("GetAllLocales",true);
            }


        }]);//service end
    function getLookupsFromServer(service,resultHolder,tmxUtility,groupBasis,success,lookupDictionary){
     
        service.all().then(
            function(response){// Get all lookups
                resultHolder.lookups=groupResources(tmxUtility,response.data,groupBasis);//Save their local copy after grouping them by type
                function lookupTwoValues(lkp1,lkp2){
                    if (lkp1.VisibleValue<lkp2.VisibleValue) return -1;
                    if (lkp1.VisibleValue>lkp2.VisibleValue) return 1;
                    if (lkp1.VisibleValue==lkp2.VisibleValue) return 0;
                }
                // eslint-disable-next-line no-unused-vars
                function sortALookupType(typename){
                    resultHolder.lookups[typename]=resultHolder.lookups[typename].sort(lookupTwoValues);
                }
          // resultHolder.lookups.names.forEach(sortALookupType);

                function addToDictionary(item){
                    lookupDictionary[item.LookupId] = item;
                }

                response.Data.forEach(addToDictionary);
                success();
            }
        );
    }

    function groupResources(tmxUtility,allResources,onBasisOf){
        var groups=tmxUtility.groupBy(allResources,onBasisOf);
        return groups;
    }

    function onBasisOfType(obj){
        return obj.LookupType;//We can add multiple attributes to group on
    }


})();